import API from './api';

export default {
  getReferralsInfo() {
    return API.get('/api/referrals/info');
  },
  sendReferral(email) {
    return API.post('/api/referrals/invite', { email });
  },
  getReferralLink(hashedId) {
    return API.get(`/api/referrals/invite/${hashedId}`);
  },
};
